/**
 * PromoCodeModal
 * @description This component show 'Apply Promocode' modal with form.
 * @author Tirumal Rao
 */
import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Message } from 'semantic-ui-react';
import { reduxForm, Field, unregisterField, change } from 'redux-form';
import { closeModal } from '../../modals/modalActions';
import { applyPromoCode, resetPromoCode } from '../PaymentActions';
import TextInput from '../../../app/common/Form/TextInput';

/**
 * CONFIGURATIONS START
 */

const formName = 'addMoneyForm';

// Redux actions
const actions = dispatch => ({
  changeFieldValue: (form, field) => {
    dispatch(unregisterField(form, field));
    dispatch(change(form, field, ''));
    dispatch(closeModal());
  },
  closeModal: () => {
    dispatch(closeModal());
  },
  applyPromoCode: (promocode, amount, csrf) => {
    dispatch(applyPromoCode(promocode, amount, csrf));
  },
  resetPromo: () => {
    dispatch(resetPromoCode());
  }
});

// Redux state
const mapState = state => ({
  auth: state.auth,
  async: state.async,
  formValues: state.form.addMoneyForm,
  promoCode: state.payment.promoCode
});

/**
 * CONFIGURATIONS ENDS
 */

class PromoCodeModal extends Component {
  static propTypes = {
    async: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    changeFieldValue: PropTypes.func.isRequired,
    applyPromoCode: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    promoCode: PropTypes.object,
    resetPromo: PropTypes.func.isRequired
  };

  // init state
  state = {
    promoCode: '',
    showError: false,
    success: false,
  };

  constructor(props) {
    super(props);

    props.resetPromo();
    
  }

  /**
   * applyPromocode
   * @description Request the service for applying promocode via payment actions.
   * @property applyPromoCode, resetPromo, auth
   * @async
   */
  applyPromoCode = (e) => {
    e.preventDefault();
    if (this.state.promoCode) {
      this.props.resetPromo();
      this.setState({
        showError: false,
      });
      this.props.applyPromoCode(
        this.state.promoCode,
        1500,
        this.props.auth.csrfRequestIdentifier
      );
    } else {
      this.setState({
        showError: true,
      });
      this.props.resetPromo();
    }
  };

  /**
   * resetField
   * @description reset promo code values from the parent form in Redux
   * @property changeFieldValue, resetPromo
   */
  resetField = () => {
    const { changeFieldValue, resetPromo } = this.props;
    changeFieldValue(formName, 'promo-code');
    resetPromo();
  };

  /**
   * promoCodeOnChange
   * @description manage controller input of promocode and change the state
   */
  promoCodeOnChange = e => {
    this.setState({
      promoCode: e.target.value
    });
  };

  render() {
    const { async, closeModal, promoCode } = this.props;
    return (
      <Modal size="mini" open={true} onClose={closeModal}>
        <Modal.Header>{(async.key === 'applypromocode' && async.loading) ? async.message : 'Apply Promocode'}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form
              loading={(async.key === 'applypromocode' && async.loading) || false}
              error={(promoCode && promoCode.errorCode) || false}
              warning={this.state.showError || false}
              success={this.state.success}
              onSubmit={this.applyPromoCode.bind(this)}
            >
              {this.state.showError && (
                <Message warning>
                  <Message.Header>Warning</Message.Header>
                  <p>You must enter promocode before applying!</p>
                </Message>
              )}
              <Message success>
                <Message.Header>Success!</Message.Header>
                <p>Successfully applied promocode!</p>
              </Message>
              <Message error>
                 <Message.Header>Promocode Error!</Message.Header>
                <p>{
                  (promoCode && promoCode.errors) ||
                  'Unable to apply promocode, please try again'
                }</p>
              </Message>
              <Field
                name="promo-code"
                placeholder="ENTER PROMOCODE"
                type="text"
                component={TextInput}
                onChange={this.promoCodeOnChange}
                value={this.props.formValues['promo-code'] || ''}
              />
              <Button
                className="fcbtn fccancelbtn small"
                onClick={this.resetField}
              >
                Cancel
              </Button>
              <Button
                className="fcbtn fcprimary small"
                onClick={this.applyPromoCode}
              >
                Apply Promocode
              </Button>
            </Form>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

// Redux connect and reduxForm HOC on statefull component 'PromoCodeModal'
export default connect(
  mapState,
  actions
)(
  reduxForm({
    form: formName,
    destroyOnUnmount: false,
    enableReinitialize: true
  })(PromoCodeModal)
);
